export default {
    props: {
        tooltipTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'tooltip.template'
        }, 
        tooltipVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'tooltip.visible'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-gantt-vue-wrapper/src/KendoGantt/Tooltip.js